import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ProjectsQueryVariables = Types.Exact<{
  status?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['Int']>> | Types.InputMaybe<Types.Scalars['Int']>>;
}>;


export type ProjectsQuery = { __typename?: 'HyperionSchemaQuery', company?: { __typename?: 'Company', projects?: { __typename?: 'ProjectConnection', totalCount: number, edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: string, status?: number | null, trueId?: string | null, mark?: string | null, endDate?: string | null, startDate?: string | null, created?: string | null, todoCount?: number | null, madeBy?: string | null, orderNumber?: string | null, notInvoicedDaysCount?: number | null, shortMessage?: string | null, unMovedSupplierInvoiceRowsSTAT?: number | null, supplierInvoiceRowsSTAT?: number | null, clientInfo?: string | null, establishmentInfo?: string | null, projectTypeInfo?: string | null, isAta?: number | null, subProjectCount?: number | null, parentId?: number | null, done?: number | null, projectColor?: string | null, subProjects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: string, status?: number | null, trueId?: string | null, mark?: string | null, endDate?: string | null, startDate?: string | null, created?: string | null, todoCount?: number | null, madeBy?: string | null, orderNumber?: string | null, notInvoicedDaysCount?: number | null, shortMessage?: string | null, unMovedSupplierInvoiceRowsSTAT?: number | null, supplierInvoiceRowsSTAT?: number | null, clientInfo?: string | null, establishmentInfo?: string | null, projectTypeInfo?: string | null, isAta?: number | null, subProjectCount?: number | null, parentId?: number | null, done?: number | null, projectColor?: string | null, type?: { __typename?: 'CompanyProjectType', name?: string | null, prefix?: string | null, formattedName?: string | null } | null, todos?: { __typename?: 'TodoConnection', totalCount: number, edges?: Array<{ __typename?: 'TodoEdge', node?: { __typename?: 'Todo', done?: number | null } | null } | null> | null } | null, mainProject?: { __typename?: 'Project', id: string, trueId?: string | null, status?: number | null } | null } | null } | null> | null } | null, type?: { __typename?: 'CompanyProjectType', name?: string | null, prefix?: string | null, formattedName?: string | null } | null, todos?: { __typename?: 'TodoConnection', totalCount: number, edges?: Array<{ __typename?: 'TodoEdge', node?: { __typename?: 'Todo', done?: number | null } | null } | null> | null } | null, mainProject?: { __typename?: 'Project', id: string, trueId?: string | null, status?: number | null } | null } | null } | null> | null } | null } | null };

export type ProjectsDeletedLazyQueryVariables = Types.Exact<{
  last?: Types.InputMaybe<Types.Scalars['Int']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  sortColumn?: Types.InputMaybe<Types.Scalars['String']>;
  typeId?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['Int']>> | Types.InputMaybe<Types.Scalars['Int']>>;
  status?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['Int']>> | Types.InputMaybe<Types.Scalars['Int']>>;
}>;


export type ProjectsDeletedLazyQuery = { __typename?: 'HyperionSchemaQuery', company?: { __typename?: 'Company', projectsWithDeleted?: { __typename?: 'ProjectConnection', totalCount: number, edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: string, status?: number | null, trueId?: string | null, mark?: string | null, endDate?: string | null, startDate?: string | null, created?: string | null, todoCount?: number | null, madeBy?: string | null, orderNumber?: string | null, notInvoicedDaysCount?: number | null, shortMessage?: string | null, unMovedSupplierInvoiceRowsSTAT?: number | null, supplierInvoiceRowsSTAT?: number | null, clientInfo?: string | null, establishmentInfo?: string | null, projectTypeInfo?: string | null, isAta?: number | null, subProjectCount?: number | null, parentId?: number | null, done?: number | null, projectColor?: string | null, subProjects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: string, status?: number | null, trueId?: string | null, mark?: string | null, endDate?: string | null, startDate?: string | null, created?: string | null, todoCount?: number | null, madeBy?: string | null, orderNumber?: string | null, notInvoicedDaysCount?: number | null, shortMessage?: string | null, unMovedSupplierInvoiceRowsSTAT?: number | null, supplierInvoiceRowsSTAT?: number | null, clientInfo?: string | null, establishmentInfo?: string | null, projectTypeInfo?: string | null, isAta?: number | null, subProjectCount?: number | null, parentId?: number | null, done?: number | null, projectColor?: string | null, type?: { __typename?: 'CompanyProjectType', name?: string | null, prefix?: string | null, formattedName?: string | null } | null, todos?: { __typename?: 'TodoConnection', totalCount: number, edges?: Array<{ __typename?: 'TodoEdge', node?: { __typename?: 'Todo', done?: number | null } | null } | null> | null } | null, mainProject?: { __typename?: 'Project', id: string, trueId?: string | null, status?: number | null } | null } | null } | null> | null } | null, type?: { __typename?: 'CompanyProjectType', name?: string | null, prefix?: string | null, formattedName?: string | null } | null, todos?: { __typename?: 'TodoConnection', totalCount: number, edges?: Array<{ __typename?: 'TodoEdge', node?: { __typename?: 'Todo', done?: number | null } | null } | null> | null } | null, mainProject?: { __typename?: 'Project', id: string, trueId?: string | null, status?: number | null } | null } | null } | null> | null } | null } | null };

export type ProjectsLazyQueryVariables = Types.Exact<{
  status?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['Int']>> | Types.InputMaybe<Types.Scalars['Int']>>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  sortColumn?: Types.InputMaybe<Types.Scalars['String']>;
  typeId?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['Int']>> | Types.InputMaybe<Types.Scalars['Int']>>;
  search?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type ProjectsLazyQuery = { __typename?: 'HyperionSchemaQuery', company?: { __typename?: 'Company', projects?: { __typename?: 'ProjectConnection', totalCount: number, edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: string, status?: number | null, trueId?: string | null, mark?: string | null, endDate?: string | null, startDate?: string | null, created?: string | null, todoCount?: number | null, madeBy?: string | null, orderNumber?: string | null, notInvoicedDaysCount?: number | null, shortMessage?: string | null, unMovedSupplierInvoiceRowsSTAT?: number | null, supplierInvoiceRowsSTAT?: number | null, clientInfo?: string | null, establishmentInfo?: string | null, projectTypeInfo?: string | null, isAta?: number | null, subProjectCount?: number | null, parentId?: number | null, done?: number | null, projectColor?: string | null, subProjects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: string, status?: number | null, trueId?: string | null, mark?: string | null, endDate?: string | null, startDate?: string | null, created?: string | null, todoCount?: number | null, madeBy?: string | null, orderNumber?: string | null, notInvoicedDaysCount?: number | null, shortMessage?: string | null, unMovedSupplierInvoiceRowsSTAT?: number | null, supplierInvoiceRowsSTAT?: number | null, clientInfo?: string | null, establishmentInfo?: string | null, projectTypeInfo?: string | null, isAta?: number | null, subProjectCount?: number | null, parentId?: number | null, done?: number | null, projectColor?: string | null, type?: { __typename?: 'CompanyProjectType', name?: string | null, prefix?: string | null, formattedName?: string | null } | null, todos?: { __typename?: 'TodoConnection', totalCount: number, edges?: Array<{ __typename?: 'TodoEdge', node?: { __typename?: 'Todo', done?: number | null } | null } | null> | null } | null, mainProject?: { __typename?: 'Project', id: string, trueId?: string | null, status?: number | null } | null } | null } | null> | null } | null, type?: { __typename?: 'CompanyProjectType', name?: string | null, prefix?: string | null, formattedName?: string | null } | null, todos?: { __typename?: 'TodoConnection', totalCount: number, edges?: Array<{ __typename?: 'TodoEdge', node?: { __typename?: 'Todo', done?: number | null } | null } | null> | null } | null, mainProject?: { __typename?: 'Project', id: string, trueId?: string | null, status?: number | null } | null } | null } | null> | null } | null } | null };

export type ProjectFragment = { __typename?: 'Project', id: string, status?: number | null, trueId?: string | null, mark?: string | null, endDate?: string | null, startDate?: string | null, created?: string | null, todoCount?: number | null, madeBy?: string | null, orderNumber?: string | null, notInvoicedDaysCount?: number | null, shortMessage?: string | null, unMovedSupplierInvoiceRowsSTAT?: number | null, supplierInvoiceRowsSTAT?: number | null, clientInfo?: string | null, establishmentInfo?: string | null, projectTypeInfo?: string | null, isAta?: number | null, subProjectCount?: number | null, parentId?: number | null, done?: number | null, projectColor?: string | null, subProjects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: string, status?: number | null, trueId?: string | null, mark?: string | null, endDate?: string | null, startDate?: string | null, created?: string | null, todoCount?: number | null, madeBy?: string | null, orderNumber?: string | null, notInvoicedDaysCount?: number | null, shortMessage?: string | null, unMovedSupplierInvoiceRowsSTAT?: number | null, supplierInvoiceRowsSTAT?: number | null, clientInfo?: string | null, establishmentInfo?: string | null, projectTypeInfo?: string | null, isAta?: number | null, subProjectCount?: number | null, parentId?: number | null, done?: number | null, projectColor?: string | null, type?: { __typename?: 'CompanyProjectType', name?: string | null, prefix?: string | null, formattedName?: string | null } | null, todos?: { __typename?: 'TodoConnection', totalCount: number, edges?: Array<{ __typename?: 'TodoEdge', node?: { __typename?: 'Todo', done?: number | null } | null } | null> | null } | null, mainProject?: { __typename?: 'Project', id: string, trueId?: string | null, status?: number | null } | null } | null } | null> | null } | null, type?: { __typename?: 'CompanyProjectType', name?: string | null, prefix?: string | null, formattedName?: string | null } | null, todos?: { __typename?: 'TodoConnection', totalCount: number, edges?: Array<{ __typename?: 'TodoEdge', node?: { __typename?: 'Todo', done?: number | null } | null } | null> | null } | null, mainProject?: { __typename?: 'Project', id: string, trueId?: string | null, status?: number | null } | null };

export type ListSubprojectFragment = { __typename?: 'Project', id: string, status?: number | null, trueId?: string | null, mark?: string | null, endDate?: string | null, startDate?: string | null, created?: string | null, todoCount?: number | null, madeBy?: string | null, orderNumber?: string | null, notInvoicedDaysCount?: number | null, shortMessage?: string | null, unMovedSupplierInvoiceRowsSTAT?: number | null, supplierInvoiceRowsSTAT?: number | null, clientInfo?: string | null, establishmentInfo?: string | null, projectTypeInfo?: string | null, isAta?: number | null, subProjectCount?: number | null, parentId?: number | null, done?: number | null, projectColor?: string | null, type?: { __typename?: 'CompanyProjectType', name?: string | null, prefix?: string | null, formattedName?: string | null } | null, todos?: { __typename?: 'TodoConnection', totalCount: number, edges?: Array<{ __typename?: 'TodoEdge', node?: { __typename?: 'Todo', done?: number | null } | null } | null> | null } | null, mainProject?: { __typename?: 'Project', id: string, trueId?: string | null, status?: number | null } | null };

export type MoveProjectMutationVariables = Types.Exact<{
  ids?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['Int']>> | Types.InputMaybe<Types.Scalars['Int']>>;
  status?: Types.InputMaybe<Types.Scalars['Int']>;
  includeSubProjects?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type MoveProjectMutation = { __typename?: 'HyperionSchemaMutation', moveProjectToStatusMutation?: Array<{ __typename?: 'Project', id: string, mutationDetails?: Array<{ __typename?: 'ModelErrorsTypeHyperionBase', mutationSucceeded?: boolean | null, msg?: string | null } | null> | null } | null> | null };

export type FetchUserSortSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchUserSortSettingsQuery = { __typename?: 'HyperionSchemaQuery', me?: { __typename?: 'User', userGuiSortings?: { __typename?: 'UserGuiSortingConnection', edges?: Array<{ __typename?: 'UserGuiSortingEdge', node?: { __typename?: 'UserGuiSorting', id: string, ascDesc?: number | null, attribute?: string | null, object?: string | null } | null } | null> | null } | null } | null };

export type SortSettingsFragment = { __typename?: 'User', userGuiSortings?: { __typename?: 'UserGuiSortingConnection', edges?: Array<{ __typename?: 'UserGuiSortingEdge', node?: { __typename?: 'UserGuiSorting', id: string, ascDesc?: number | null, attribute?: string | null, object?: string | null } | null } | null> | null } | null };

export type UpdateUserSortSettingsMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']>;
  ascDesc?: Types.InputMaybe<Types.Scalars['Int']>;
  attribute?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type UpdateUserSortSettingsMutation = { __typename?: 'HyperionSchemaMutation', userGuiSortingTypeHyperionMutation?: { __typename?: 'UserGuiSorting', id: string, attribute?: string | null, ascDesc?: number | null } | null };

export type CreateUserSortSettingsMutationVariables = Types.Exact<{
  object?: Types.InputMaybe<Types.Scalars['String']>;
  ascDesc?: Types.InputMaybe<Types.Scalars['Int']>;
  attribute?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type CreateUserSortSettingsMutation = { __typename?: 'HyperionSchemaMutation', userGuiSortingTypeHyperionMutation?: { __typename?: 'UserGuiSorting', id: string, attribute?: string | null, ascDesc?: number | null } | null };

export type FetchProjectIdsForIncomeExportQueryVariables = Types.Exact<{
  fromDate?: Types.InputMaybe<Types.Scalars['DateTime']>;
  toDate?: Types.InputMaybe<Types.Scalars['DateTime']>;
  status?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['Int']>> | Types.InputMaybe<Types.Scalars['Int']>>;
  typeIds?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['Int']>> | Types.InputMaybe<Types.Scalars['Int']>>;
  search?: Types.InputMaybe<Types.Scalars['String']>;
  trueId?: Types.InputMaybe<Types.Scalars['String']>;
  mark?: Types.InputMaybe<Types.Scalars['String']>;
  clientInfo?: Types.InputMaybe<Types.Scalars['String']>;
  establishmentInfo?: Types.InputMaybe<Types.Scalars['String']>;
  orderNumber?: Types.InputMaybe<Types.Scalars['String']>;
  madeBy?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type FetchProjectIdsForIncomeExportQuery = { __typename?: 'HyperionSchemaQuery', company?: { __typename?: 'Company', projectsWithKpis?: { __typename?: 'ProjectWithKpisConnection', edges?: Array<{ __typename?: 'ProjectWithKpisEdge', node?: { __typename?: 'ProjectWithKpis', id?: number | null } | null } | null> | null } | null } | null };

export const ListSubprojectFragmentDoc = gql`
    fragment listSubproject on Project {
  id
  status
  trueId
  mark
  type {
    name
    prefix
    formattedName
  }
  endDate
  startDate
  created
  todoCount
  madeBy
  orderNumber
  notInvoicedDaysCount
  shortMessage
  unMovedSupplierInvoiceRowsSTAT
  supplierInvoiceRowsSTAT
  todos {
    totalCount
    edges {
      node {
        done
      }
    }
  }
  clientInfo
  establishmentInfo
  projectTypeInfo
  isAta
  mainProject {
    id
    trueId
  }
  subProjectCount
  parentId
  done
  mainProject {
    id
    trueId
    status
  }
  projectColor
}
    `;
export const ProjectFragmentDoc = gql`
    fragment project on Project {
  ...listSubproject
  subProjects(status: $status) {
    edges {
      node {
        ...listSubproject
      }
    }
  }
}
    ${ListSubprojectFragmentDoc}`;
export const SortSettingsFragmentDoc = gql`
    fragment sortSettings on User {
  userGuiSortings {
    edges {
      node {
        id
        ascDesc
        attribute
        object
      }
    }
  }
}
    `;
export const ProjectsDocument = gql`
    query projects($status: [Int]) {
  company {
    projects(fromDate: "1970-01-01", status: $status) {
      totalCount
      edges {
        node {
          ...project
        }
      }
    }
  }
}
    ${ProjectFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProjectsGQL extends Apollo.Query<ProjectsQuery, ProjectsQueryVariables> {
    document = ProjectsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProjectsDeletedLazyDocument = gql`
    query projectsDeletedLazy($last: Int, $first: Int, $offset: Int, $sortColumn: String, $typeId: [Int], $status: [Int] = [4]) {
  company {
    projectsWithDeleted(
      status: $status
      offset: $offset
      first: $first
      last: $last
      sort: $sortColumn
      typeId: $typeId
    ) {
      totalCount
      edges {
        node {
          ...project
        }
      }
    }
  }
}
    ${ProjectFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProjectsDeletedLazyGQL extends Apollo.Query<ProjectsDeletedLazyQuery, ProjectsDeletedLazyQueryVariables> {
    document = ProjectsDeletedLazyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProjectsLazyDocument = gql`
    query projectsLazy($status: [Int], $last: Int, $first: Int, $offset: Int, $sortColumn: String, $typeId: [Int], $search: String) {
  company {
    projects(
      status: $status
      offset: $offset
      first: $first
      last: $last
      sort: $sortColumn
      typeId: $typeId
      search: $search
    ) {
      totalCount
      edges {
        node {
          ...project
        }
      }
    }
  }
}
    ${ProjectFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProjectsLazyGQL extends Apollo.Query<ProjectsLazyQuery, ProjectsLazyQueryVariables> {
    document = ProjectsLazyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MoveProjectDocument = gql`
    mutation moveProject($ids: [Int], $status: Int, $includeSubProjects: Boolean) {
  moveProjectToStatusMutation(
    projectIds: $ids
    status: $status
    includeSubprojects: $includeSubProjects
  ) {
    id
    mutationDetails {
      mutationSucceeded
      msg
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MoveProjectGQL extends Apollo.Mutation<MoveProjectMutation, MoveProjectMutationVariables> {
    document = MoveProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchUserSortSettingsDocument = gql`
    query fetchUserSortSettings {
  me {
    ...sortSettings
  }
}
    ${SortSettingsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchUserSortSettingsGQL extends Apollo.Query<FetchUserSortSettingsQuery, FetchUserSortSettingsQueryVariables> {
    document = FetchUserSortSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserSortSettingsDocument = gql`
    mutation updateUserSortSettings($id: Int, $ascDesc: Int, $attribute: String) {
  userGuiSortingTypeHyperionMutation(
    updateUserGuiSorting: {id: $id, ascDesc: $ascDesc, attribute: $attribute}
  ) {
    id
    attribute
    ascDesc
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserSortSettingsGQL extends Apollo.Mutation<UpdateUserSortSettingsMutation, UpdateUserSortSettingsMutationVariables> {
    document = UpdateUserSortSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserSortSettingsDocument = gql`
    mutation createUserSortSettings($object: String, $ascDesc: Int, $attribute: String) {
  userGuiSortingTypeHyperionMutation(
    createUserGuiSorting: {object: $object, ascDesc: $ascDesc, attribute: $attribute}
  ) {
    id
    attribute
    ascDesc
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserSortSettingsGQL extends Apollo.Mutation<CreateUserSortSettingsMutation, CreateUserSortSettingsMutationVariables> {
    document = CreateUserSortSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchProjectIdsForIncomeExportDocument = gql`
    query fetchProjectIdsForIncomeExport($fromDate: DateTime, $toDate: DateTime, $status: [Int], $typeIds: [Int], $search: String, $trueId: String, $mark: String, $clientInfo: String, $establishmentInfo: String, $orderNumber: String, $madeBy: String) {
  company {
    projectsWithKpis(
      fromDate: $fromDate
      toDate: $toDate
      status: $status
      typeIds: $typeIds
      search: $search
      trueId: $trueId
      mark: $mark
      clientInfo: $clientInfo
      establishmentInfo: $establishmentInfo
      orderNumber: $orderNumber
      madeBy: $madeBy
    ) {
      edges {
        node {
          id
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchProjectIdsForIncomeExportGQL extends Apollo.Query<FetchProjectIdsForIncomeExportQuery, FetchProjectIdsForIncomeExportQueryVariables> {
    document = FetchProjectIdsForIncomeExportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }